<!-- 红包：表单 -->
<template>
  <div>
    <transition name="media-scale">
      <div class="media-scale">
        <el-dialog
          v-bind="$attrs"
          v-on="$listeners"
          :key="'dialog'"
          :visible="isShowRedPacket"
          :modal="false"
          :close-on-click-modal="false"
          :title="title"
          :width="dialogW"
          class="dialog-dark dialog-center form-dark toolNormalDialog set-padding"
          @close="onClose"
        >
          <!-- 红包创建 -->
          <div class="modal-con-col" v-if="curPage == 0">
            <div class="left-nav">
              <el-scrollbar style="height: calc(100% - 5px)" ref="scrollbarRef">
                <ul>
                  <li
                    v-for="info in packetList"
                    :key="info.type"
                    :class="{ cur: curType == `${info.type}` }"
                    @click="changeType(info.type)"
                  >
                    {{ $t(`redpacket.${info.name}`)  }}
                  </li>
                </ul>
              </el-scrollbar>
            </div>
            <div class="rightContent">
              <span class="giveRecord" @click="openRecord">{{
                $t("redpacket.giveRecord")
              }}</span>
              <el-form
                ref="redPacketElForm"
                :model="form"
                label-position="right"
                label-width="100px"
                size="small"
                style="text-align: left"
                class="redPacketFrom scrollbar"
              >
                <el-form-item :label="$t('redpacket.type')" prop="algorithm">
                  <el-radio-group
                    @input="changeRedpacketType"
                    v-model="form.algorithm"
                    size="mini"
                    class="radio-group-mini"

                  >
                    <el-radio :label="0">{{ $t("redpacket.random") }}</el-radio>
                    <el-radio :label="1">{{ $t("redpacket.equal") }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  :label="
                    form.algorithm == 0
                      ? $t('redpacket.amount')
                      : $t('redpacket.onePrice')
                  "
                  prop="amount"
                >
                  <el-input
                    v-model="form.amount"
                    class="input"
                    :placeholder="$t('redpacket.priceDefault')"
                  ></el-input>
                  <span class="inputRight">{{ $t("redpacket.yuan") }}</span>
                  <p class="inputTips" v-if="form.algorithm == 0">
                    {{ $t("redpacket.amountTips") }}
                  </p>
                  <p class="inputTips" v-else>
                    {{ $t("redpacket.onePriceTips") }}
                  </p>
                </el-form-item>
                <el-form-item
                  :label="$t('redpacket.sendCount')"
                  prop="sendCount"
                >
                  <el-input
                    v-model="form.sendCount"
                    class="input"
                    maxlength="3"
                  ></el-input>
                  <span class="inputRight"
                    >{{ $t("redpacket.audienceNum") }}{{ userNumber
                    }}{{ $t("redpacket.people") }}</span
                  >
                  <p class="inputTips">{{ $t("redpacket.sendCountTips") }}</p>
                </el-form-item>
                <el-form-item
                  v-if="form.algorithm == 1"
                  :label="$t('redpacket.amount')"
                >
                  ¥ {{ (form.amount * form.sendCount).toFixed(2) }}
                </el-form-item>
                <!-- 红包口令 -->
                <el-form-item
                  :label="$t('redpacket.packetPsd')"
                  prop="password"
                  v-if="curType == 1"
                  class="set-padding"
                >
                  <el-input
                    v-model="form.password"
                    class="input"
                    maxlength="16"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <!-- 口令提示 -->
                <el-form-item
                  v-if="curType == 1"
                  :label="$t('redpacket.passwordTips')"
                  prop="passwordTips"
                >
                  <el-input
                    v-model="form.passwordTips"
                    class="input"
                    maxlength="16"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="$t('redpacket.sendTime')"
                  prop="sendTimeType"
                >
                  <el-radio-group
                    v-model="form.sendTimeType"
                    size="mini"
                    class="radio-group-mini"
                  >
                    <el-radio :label="0">{{
                      $t("redpacket.realTime")
                    }}</el-radio>
                    <el-radio :label="1">{{
                      $t("redpacket.startTime")
                    }}</el-radio>
                  </el-radio-group>
                  <el-date-picker
                    v-show="form.sendTimeType == 1"
                    v-model="form.startTime"
                    type="datetime"
                    :placeholder="$t('redpacket.selectDateTime')"
                    class="startTime input"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  :label="$t('redpacket.blessingWords')"
                  prop="blessingWords"
                  v-if="curType != 2"
                >
                  <el-input
                    v-model="form.blessingWords"
                    class="input"
                    maxlength="10"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-form>
              <div class="bottom-nav">
                <span>{{ $t("redpacket.onlySupport") }}</span>
                <el-button
                  class="button-mini"
                  size="mini"
                  type="primary"
                  @click="onSubmit"
                  :disabled="disabled"
                  :loading="loading"
                  >{{ $t("message.确定") }}</el-button
                >
              </div>
            </div>
          </div>
          <redPacketPay v-if="curPage == 1" :creRes="creRes" />
        </el-dialog>
      </div>
    </transition>
  </div>
</template>

<script>
import { createRedpacket } from "@/api/redPacket";
import redPacketPay from "./pay";
import {
  Form,
  FormItem,
  Input,
  Radio,
  RadioGroup,
  DatePicker,
} from "element-ui";
import { mapGetters } from "vuex";
export default {
  name: "redPacketForm",
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [DatePicker.name]: DatePicker,
    redPacketPay,
  },
  watch: {
    "form.amount": {
      handler(val) {
        console.log(typeof val);
        if (typeof val == "number") return;
        this.form.amount = val.match(/^\d*(\.?\d{0,2})/g)[0] || "";
      },
    },
    "form.sendCount": {
      handler(val) {
        if (typeof val == "number") return;
        this.form.sendCount = (val.match(/^\d*/g)[0] || "").replace(
          /\b(0+)/gi,
          ""
        );
      },
    },
    isShowRedPacket: {
      handler(val) {
        if (val) {
          this.curPage = 0;
          this.dialogW = "760px";
        }
      },
    },
  },
  computed: {
    ...mapGetters([
      "isShowRedPacket",
      "userNumber",
      "liveRoomStatus",
      "confId",
      "liveId",
      "userInfo",
    ]),
    disabled() {
      if (this.curType == 0) {
        return this.form.amount != "" &&
          this.form.sendCount != "" &&
          this.form.blessingWords != "" &&
          (this.form.sendTimeType == 0 ||
            (this.form.sendTimeType == 1 &&
              this.form.startTime != "" &&
              this.form.startTime))
          ? false
          : true;
      } else if (this.curType == 1) {
        return this.form.amount != "" &&
          this.form.sendCount != "" &&
          this.form.password != "" &&
          this.form.blessingWords != "" &&
          this.form.passwordTips != "" &&
          (this.form.sendTimeType == 0 ||
            (this.form.sendTimeType == 1 &&
              this.form.startTime != "" &&
              this.form.startTime))
          ? false
          : true;
      } else {
        return this.form.amount != "" &&
          this.form.sendCount != "" &&
          (this.form.sendTimeType == 0 ||
            (this.form.sendTimeType == 1 &&
              this.form.startTime != "" &&
              this.form.startTime))
          ? false
          : true;
      }
    },
  },
  data() {
    return {
      packetList: [
        { type: 0, name: 'normal'},
        { type: 1, name: 'passwd'},
        { type: 2, name: 'redPacketRain'},
      ],
      curType: 0,
      form: {
        algorithm: 0, //红包类型
        amount: "", //总金额
        sendCount: "", //红包个数
        sendTimeType: 0, //发送时间类型
        blessingWords: this.$t("redpacket.defaultBlessing"), //祝福语
        startTime: new Date(), //定时时间
        password: "", //红包口令
        passwordTips: "", //口令提示
      },
      curPage: 0, //0->表单  1->支付
      title: this.$t("redpacket.redPacket"),
      dialogW: "760px",
      creRes: {}, //创建结果
      loading: false,
    };
  },
  methods: {
    openRecord() {
      this.$store.commit("SET_SHOW_RED_PACKET_RECORD", true);
    },
    onClose() {
      this.title = this.$t("redpacket.redPacket");
      this.$store.commit("SET_SHOW_RED_PACKET", false);
      this.changeType(0);
    },
    changeType(type) {
      this.curType = type;
      this.form = {
        algorithm: 0, //红包类型
        amount: "", //总金额
        sendCount: "", //红包个数
        sendTimeType: 0, //发送时间类型
        blessingWords: this.$t("redpacket.defaultBlessing"), //祝福语
        startTime: null, //定时时间
        password: "", //红包口令
        passwordTips: "", //口令提示
      };
      this.$refs["redPacketElForm"] &&
        this.$refs["redPacketElForm"].resetFields();
    },
    onSubmit() {
      console.log(this.form);
      if (
        (this.form.algorithm != 1 && (this.form.amount > 19999 || this.form.amount < 1)) || (this.form.algorithm == 1 && ((this.form.amount * this.form.sendCount) > 19999 || (this.form.amount * this.form.sendCount) < 1)
      ))
        return this.$message.error(this.$t("redpacket.inputSumPriceTips"));
      if (this.form.algorithm == 1 && this.form.amount > 9999)
        return this.$message.error(this.$t("redpacket.onePriceTips"));
      if (this.curType != 2 && this.form.sendCount > this.userNumber)
        return this.$message.error(this.$t("redpacket.numberLimitTips"));
      if (
        this.form.sendTimeType == 1 &&
        this.form.startTime.valueOf() < new Date().getTime()
      )
        return this.$message.error(this.$t("redpacket.timeLimitTips"));
      if (this.liveRoomStatus != 2)
        return this.$message.error(this.$t("redpacket.noStartTips"));
      this.form.amount = Number(this.form.amount);
      this.form.sendCount = Number(this.form.sendCount);
      if (this.form.sendTimeType == 0) {
        delete this.form.startTime;
      }
      let from = JSON.parse(JSON.stringify(this.form));
      if (from.algorithm == 1) {
        from.perAmount = this.form.amount;
        from.amount = this.form.amount * this.form.sendCount;
      }
      this.loading = true;

      from.perAmount = from.perAmount * 100;
      from.amount = from.amount * 100;
      const subInfo = Object.assign(from, {
        confId: this.confId,
        liveId: this.liveId,
        type: this.curType,
        userName: this.userInfo.name,
        cid: this.userInfo.cid,
        userId: this.userInfo.uid,
        userDev: "web",
        userRole: 6,
      });
      console.log(subInfo);
      createRedpacket(subInfo).then((resp) => {
        if (resp.status === 0) {
          // let tipsObj = {
          //   confirmButtonText: "我知道了",
          //   customClass: "tip-alert text-left redpacket-tip",
          //   showCancelButton: false,
          // };
          this.loading = false;
          // this.$confirm(this.$t("redpacket.wechatPayTips"), "提示", tipsObj)
          //   .then(() => {
              this.curPage = 1; //去支付
              this.title = this.$t("redpacket.redPacketPay");
              this.dialogW = "400px";
              this.creRes = resp.data;
            // })
            // .catch(() => {});
        } else {
          if (resp.status == 210109) {
            this.$message.error(this.$t("redpacket.onePriceTips"));
          } else if (resp.status == 110106) {
            this.$message.error(this.$t("redpacket.inputSumPriceTips"));
          } else if(resp.status == 210104) {
            this.$message.error(this.$t("redpacket.paySettingFail"));
          } else {
            this.$message.error(resp.message);
          }
          this.loading = false;
        }
      });
    },
    changeRedpacketType(){
       this.form.amount = ""
    }
  },
};
</script>

<style scoped lang="scss">
.left-nav ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.left-nav {
  width: 25%;

  float: left;
  height: 380px;
  li {
    height: 48px;
    line-height: 48px;
    cursor: pointer;
    font-size: 14px;
    color: #acb2bf;
  }
  .cur {
    font-size: 16px;
    color: $white-color;
    background: $back-answer-color;
  }
}
.rightContent {
  height: 480px;
  float: left;
  width: calc(75% - 64px);
  background: $back-answer-color;
  padding: 20px 32px;
  position: relative;
  .redPacketFrom {
    height: 420px;
    overflow-y: auto;
  }
  .giveRecord {
    position: absolute;
    right: 32px;
    font-size: 12px;
    color: #3986ee;
    cursor: pointer;
    z-index: 1;
    top: 28px;
  }
  .input {
    width: 270px;
  }
  .inputRight {
    font-size: 12px;
    margin-left: 12px;
  }
  .inputTips {
    color: $gray6-color;
    line-height: 17px;
    margin-top: 6px;
    font-size: 12px;
  }
  .startTime {
    display: block;
  }
  .bottom-nav {
    position: absolute;
    bottom: 24px;
    display: flex;
    justify-content: space-between;
    width: calc(100% - 64px);
    span {
      font-size: 12px;
      color: $gray6-color;
    }
  }
}
::v-deep .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
::v-deep .el-radio-group {
  width: 270px;
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
}
::v-deep .el-date-editor {
  margin-top: 6px;
}
.set-padding ::v-deep .el-input__inner {
  padding-right: 40px;
  border-color: #525366;
}
</style>